export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./redpipe-frame.vue?vue&type=template&id=78dec151"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/redpipe/redpipe-frame.vue?vue&type=template&id=78dec151
// module id = hKtB
// module chunks = 0